import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Stack,
  Radio,
  Typography,
  FormControl,
  FormControlLabel,
  RadioGroup,
} from "@mui/material";

import { Header, MainColorButton } from "../../components";
import { bottomButton } from "../../common/styles";
import { INSURANCE_INFORMATION } from "../../routes/path";

/**
 * 処方箋申込　[受取方法]
 * @returns
 */
const ReceptionMethod = () => {
  const [endY, setEndY] = useState(0);
  const navigate = useNavigate();
  const [director, setDirector] = useState("1");

  return (
    <div
      onTouchStartCapture={(e) => {
        setEndY(0);
      }}
      onTouchMoveCapture={(e) => {
        setEndY(e.touches[0].clientY);
      }}
      onTouchEndCapture={(e) => {
        if (endY !== 0) {
          e.stopPropagation();
        }
      }}
    >
      <Header title="処方箋申込　[受取方法]" />
      <Box
        height="81vh"
        marginTop="9vh"
        width="95%"
        marginLeft="auto"
        marginRight="auto"
      >
        <Stack>
          <Typography variant="subtitle1" align="left">
            処方箋の受取方法を選択してください。
          </Typography>
          <Box width="70%" marginLeft="auto" marginRight="auto" marginTop="5%">
            <FormControl fullWidth>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={director}
                onChange={(event) => {
                  setDirector(event.target.value);
                }}
                name="radio-buttons-group"
              >
                <FormControlLabel
                  value="2"
                  control={<Radio />}
                  label="ロッカー"
                />
                <FormControlLabel value="1" control={<Radio />} label="対面" />
              </RadioGroup>
            </FormControl>
          </Box>
        </Stack>
      </Box>
      <MainColorButton
        label="次へ"
        onClick={() => navigate(INSURANCE_INFORMATION)}
        style={bottomButton}
      />
    </div>
  );
};

export default ReceptionMethod;
